// extracted by mini-css-extract-plugin
module.exports = {"root":"file_root__39KGX","documentPage":"file_documentPage__CadA4"};